/**
 * Resolve variables in a configuration object using one or two data sources.
 * @param {Object} config - Object with the templates {key} or {[form].${key}}
 * @param {Object} source1 - Primary data source (Priority).
 * @param {Object} [source2={}] - Secondary data source (Optional).
 * @param {string} [prefix] - Prefijo opcional (ej. "product").
 */

import { isNotEmptyObject } from "../utils/jsonValidator";

export function resolveConfig(config, source1, source2 = {}, prefix = null) {

    const getValue = (rawKey) => {
        const cleanKey = rawKey.replace(/[${}[\]]|form\./g, '').trim();

        const sources = [source1, source2];
        for (const src of sources) {
            if (!isNotEmptyObject(src)) continue;

            if (prefix) {
                const prefixedKey = cleanKey;
                const newFixes = prefixedKey.replace(`${prefix}_`, '');
                if (Object.prototype.hasOwnProperty.call(src, newFixes)) {
                    return src[newFixes];
                }
            } else
                if (Object.prototype.hasOwnProperty.call(src, cleanKey)) {
                    return src[cleanKey];
                }
        }

        return `{${rawKey}}`;
    };

    const process = (item) => {
        if (typeof item === 'string') {
            return item.replace(/\{([^}]+)\}/g, (_, key) => getValue(key));
        }
        if (Array.isArray(item)) return item.map(process);
        if (typeof item === 'object' && item !== null) {
            const copy = {};
            for (const key in item) copy[key] = process(item[key]);
            return copy;
        }
        return item;
    };

    return process(config);
};